export const COMPLETION_STATES = {
  COMPLETED: 'completed',
  RETURNED: 'returned',
  STARTED: 'started'
} as const;

export type CompletionState = typeof COMPLETION_STATES[keyof typeof COMPLETION_STATES];

export interface CompletionError {
  status: number;
  message: string;
  data?: unknown;
}